/**
 * route.js
 */

import React from 'react';
import { Route as ReactRoute, Redirect } from "react-router-dom";
import { UserContext } from 'contexts/user/user-context';
import { DogsContext } from 'contexts/dogs/dogs-context';
import { validateLocation } from 'utils/user-validation';


export default function Route(props) {
  const { user, admin } = React.useContext(UserContext);
  const { dogs } = React.useContext(DogsContext);


  const redirect = (path, location) => {
    return <Redirect
      to={{
        pathname: path,
        state: { from: location }
      }}
    />;
  }


  return (
    <>
      <ReactRoute
        path={props.path}
        computedMatch={props.computedMatch}
        exact={props.exact}
        render={({ location }) => {
          if (user) {
            const action = validateLocation(user, dogs, admin, location.pathname);

            if (action && action.location) {
              window.location = action.location;
              return;
            } else if (action && action.route) {
              return redirect(action.route, location);
            }
          }

          return <ReactRoute {...props} />;
        }}
      />
    </>
  );
}
